'use client';
const sliceItems = (items, maxItems)=>{
    if (!items) {
        return [];
    }
    if (!maxItems) {
        return items;
    }
    return items.slice(0, maxItems);
};

export { sliceItems };
//# sourceMappingURL=sliceItems.js.map
